import Card from "components/Card/Card.jsx";
import Select from "react-select";
import Collapsible from "react-collapsible";
import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import axios from "axios";
import { style } from "../../../variables/Variables";
import React, { Component } from "react";
import LoadingOrder from "views/Components/loadingOrder";
import LoadingMedication from "views/Components/loadingMedication";
import { extendMoment } from "moment-range";
import originalMoment from "moment";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  Col,
  FormControl,
  FormGroup,
  Grid,
  Row,
  Modal,
  ControlLabel,
  Table,
  Pagination,
} from "react-bootstrap";
import {
  getGoodRetunShow,
  getallUsers,
  searchMedicationForOrder,
  SendGoodReturnValue,
} from "api/purchaseOrder/PurchaseOrder";
import { getAllMedication } from "../../../Listfunction";
import LoadingSpinner from "views/Components/loadingSpinner";
import ScreenLoader from "views/Components/screenLoader";
import LoadingPdfSpinner from "views/Components/loadingPdfSpinner";
import AsyncSelect from "react-select/lib/Async";
import { getApiErrorMessage } from "../../../utils/getApiErrorMessage";
const moment = extendMoment(originalMoment);

class goodReturnNote extends Component {
  constructor(props) {
    super(props);
    const today = moment();
    this.state = {
      currentPage: 1,
      showGrnPop: false,
      pdfloading: false,
      wrongGoods: false,
      excessGoods: false,
      damageGoods: false,
      other: false,
      isLoading: false,
      OtherNote: "",
      searchUser: [],
      searchUserDeatils: [],
      users: "",
      user_detail: "",
      user_detailsError: null,
      unitprice: "",
      quantity: "",
      subtotal: "",
      basketvalue: "0.00",
      getGoodReturnValue: [],
      supplierList: [],
      username: "",
      loading: false,
      name: "",
      nameError: null,
      mobileno: "",
      mobilenoError: null,
      status: "1",
      statusError: null,
      phoneno: "",
      phonenoError: null,
      email: "",
      emailError: null,
      addressline1: "",
      addressline1Error: null,
      addressline2: "",
      city: "0",
      cityError: null,
      postalcode: "",
      postalcodeError: null,
      country: "0",
      countryError: null,
      latiAndLogitError: null,
      address_form_data: [],
      order_form_detail: [],
      m_id: [],
      companyname: "",
      discount: 0,
      companynote: "",
      _notificationSystem: null,
      cardHidden: true,
      medicationdataList: [],
      lastsubscription: [],
      showModal: false,
      showaddressModal: false,
      subscriptiondetail: [],
      medicationdata: [],
      quanitydata: [],
      addressdata: [],
      address_id: "",
      addressaccess: "0",
      inputList: [],
      alert: null,
      medicationaddError: null,
      marginmodal: false,
      discountmodal: false,
      margintype: "1",
      discountpercentage: 0,
      marginpercentage: 0,
      marginamount: 0,
      b2borganizationdiscount: 0,
      showmediactonModal: false,
      medicationitemcode: "",
      medicationitemcodeError: null,
      medicationdescription: "",
      medicationdescriptionError: null,
      medicationitemname: "",
      medicationitemnameError: null,
      medicationcategory: "0",
      medicationcategoryError: null,
      medicationaddcommision: "1",
      medicationis_featured: "2",
      medicationcity: "0",
      medicationcityError: null,
      medicationprice: 0,
      category_detail: [],
      marginfinalamount: 0,
      displaymarginamount: "",
      displaymarginpercentage: "",
      dynamicfinalpercentage: 0,
      b2baccess: 0,
      city_id: "",
      errormessages: [],
      medicationerrormessage: [],
      addnewaddress: false,
      healthcondition: null,
      paymentoption: null,
      paymentoptionError: null,
      currentMedicineIndex: "",
      selectedUser: null,
      not_get_medicine: "",
      quantity: "",
      medicationOptions: [],
      localMedicationData: [],
      allMedicine: [],

      datarange: moment.range(today.clone(), today.clone().add(7, "days")),

      item_type: "1",
      packageItems: [],
      labpackage: [],
      packageItemss: [],
      totalPage: null,
      wholeReason: "",
      globalOtherNote: "",
    };
    this.selectRefs = [];
    this.medSearchCache = {};
    this.inputRef = React.createRef();
    this.barcodeInputRef = React.createRef();
    this.onSubmit = this.onSubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.medication_item_code_error = React.createRef();
    this.message_error = React.createRef();
    this.inputOnChange = this.inputOnChange.bind(this);
  }
  handleAddClick = () => {
    const selected = this.state.wholeReason || {};
    const globalOther = this.state.globalOtherNote || "";
    var serial = 1;
    this.setState(
      {
        inputList: [
          ...this.state.inputList,
          {
            id: moment().valueOf(),
            srno: this.getSerial(),
            unitprice: "",
            item_type: "1",
            quantity: 1,
            medicationItems: [],
            selectmedication: "",
            wrongGoods: selected && selected.value === "Wrong Goods",
            excessGoods: selected && selected.value === "Excess Goods",
            damageGoods: selected && selected.value === "Damage Goods",
            other: selected && selected.value === "Other",
            OtherNote:
              selected && selected.value === "Other" ? globalOther : "",
          },
        ],
      },
      () => {
        const lastIndex = this.state.inputList.length - 1;
        if (this.selectRefs[lastIndex]) {
          this.selectRefs[lastIndex].focus();
        }
      },
    );
  };

  componentDidMount() {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    this.getTheDataForTheGoodReturnNote(this.state.currentPage);
    this.handleGetAllMedication();
  }
  openModal = () => {
    const defaultRows = [];
    for (let i = 0; i < 3; i++) {
      defaultRows.push({
        id: moment().valueOf() + i,
        srno: i + 1,
        unitprice: "",
        item_type: "1",
        quantity: 1,
        medicationItems: [],
        selectmedication: "",
        wrongGoods: false,
        excessGoods: false,
        damageGoods: false,
        other: false,
        OtherNote: "",
      });
    }
    this.setState({ showGrnPop: true, inputList: defaultRows }, () => {
      setTimeout(() => {
        if (this.selectRefs[0] && this.selectRefs[0].focus) {
          this.selectRefs[0].focus();
        }
      }, 200);
    });
  };
  handleGetAllMedication = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const store = token.store_id;
    await getAllMedication(obj, store)
      // .then((response) => response.json())
      .then((response) => {
        const mdata = response.data;
        console.log(response.data, "peracetamol");
        // this.setState({ allMedicine: mdata });
        const medicationOptions = mdata.map((medication) => ({
          value: medication.id,
          label: `${medication.title} (${medication.item_code})`,
        }));
        this.setState({ medicationOptions: medicationOptions });
        this.setState({ localMedicationData: mdata }, () => {
          // build local search index for fast client-side lookups
          if (
            this.state.localMedicationData &&
            this.state.localMedicationData.length > 0
          ) {
            this.buildMedIndex(this.state.localMedicationData);
          }
        });
      });
  };
  soundex(str) {
    if (!str) return "";
    const s = str.toUpperCase().replace(/[^A-Z]/g, "");
    if (s.length === 0) return "";
    const first = s[0];
    const mapping = {
      B: "1",
      F: "1",
      P: "1",
      V: "1",
      C: "2",
      G: "2",
      J: "2",
      K: "2",
      Q: "2",
      S: "2",
      X: "2",
      Z: "2",
      D: "3",
      T: "3",
      L: "4",
      M: "5",
      N: "5",
      R: "6",
    };
    let prev = mapping[first] || "";
    let out = first;
    for (let i = 1; i < s.length && out.length < 4; i++) {
      const ch = s[i];
      const code = mapping[ch] || "0";
      if (code === prev) continue;
      if (code !== "0") {
        out += code;
      }
      prev = code;
    }
    // pad with zeros
    return out.padEnd(4, "0").slice(0, 4);
  }
  buildMedIndex = (medArray) => {
    try {
      this.medIndex = medArray.map((m) => {
        const label = `${m.title} (${m.item_code})`;
        const labelLower = (label || "").toLowerCase();
        let sdx = "";
        try {
          sdx = this.soundex(labelLower);
        } catch (e) {
          sdx = "";
        }
        return { value: m.id, label, labelLower, soundex: sdx };
      });
      // sort for stable prefix scanning
      this.medIndex.sort((a, b) => (a.labelLower > b.labelLower ? 1 : -1));
    } catch (e) {
      this.medIndex = [];
    }
  };
  loadMedicationOptions = (inputValue) => {
    // require at least 2 characters to reduce work
    if (!inputValue || inputValue.trim().length < 2) return Promise.resolve([]);

    const q = inputValue.trim();

    // return cached result when available
    if (this.medSearchCache[q]) {
      return Promise.resolve(this.medSearchCache[q]);
    }

    // ensure medIndex is built from localMedicationData when available
    if (
      (!this.medIndex || this.medIndex.length === 0) &&
      this.state.localMedicationData &&
      this.state.localMedicationData.length > 0
    ) {
      this.buildMedIndex(this.state.localMedicationData);
    }

    // debounce filter: returns a promise resolved after debounce
    return new Promise((resolve) => {
      if (this._loadMedTimer) clearTimeout(this._loadMedTimer);
      this._loadMedTimer = setTimeout(() => {
        // If we have local data index, filter locally (fast)
        if (this.medIndex && this.medIndex.length > 0) {
          const lower = q.toLowerCase();
          const results = [];
          const LIMIT = 50;

          // 1) prefix matches
          for (
            let i = 0;
            i < this.medIndex.length && results.length < LIMIT;
            i++
          ) {
            const m = this.medIndex[i];
            if (m.labelLower.startsWith(lower)) results.push(m);
          }

          // 2) substring matches
          if (results.length < LIMIT) {
            for (
              let i = 0;
              i < this.medIndex.length && results.length < LIMIT;
              i++
            ) {
              const m = this.medIndex[i];
              if (results.indexOf(m) !== -1) continue;
              if (m.labelLower.includes(lower)) results.push(m);
            }
          }

          // 3) phonetic soundex fallback for longer queries
          if (results.length === 0 && lower.length >= 3) {
            const qSound = this.soundex(lower);
            for (
              let i = 0;
              i < this.medIndex.length && results.length < LIMIT;
              i++
            ) {
              const m = this.medIndex[i];
              if (m.soundex && m.soundex === qSound) results.push(m);
            }
          }

          const options = results.map((m) => ({
            value: m.value,
            label: m.label,
          }));

          // cache limited queries
          try {
            const keys = Object.keys(this.medSearchCache);
            if (keys.length > 200) delete this.medSearchCache[keys[0]];
            this.medSearchCache[q] = options;
          } catch (e) {}

          return resolve(options);
        }

        // fallback: call API once (debounced) if no local data
        this.medSearchRequestSeq++;
        const reqSeq = this.medSearchRequestSeq;
        try {
          const token = JSON.parse(localStorage.getItem("user"));
          const obj = token ? token.token : null;
          const city_id = this.state.city_id || 1;

          searchMedicationForOrder(q, city_id, 1, obj, this.state.store)
            .then((res) => {
              if (reqSeq !== this.medSearchRequestSeq) return resolve([]);
              const data = (res.data && res.data.data) || [];
              const options = data.map((medication) => ({
                value: medication.id,
                label: `${medication.title} (${medication.item_code})`,
              }));
              try {
                const keys = Object.keys(this.medSearchCache);
                if (keys.length > 200) delete this.medSearchCache[keys[0]];
                this.medSearchCache[q] = options;
              } catch (e) {}
              resolve(options);
            })
            .catch(() => resolve([]));
        } catch (e) {
          resolve([]);
        }
      }, 200);
    });
  };

  handleReasonOnChange = (e) => {
    const { name, value, checked } = e.target;

    const updatedList = this.state.inputList.map((data) => {
      if (data.id === Number(value)) {
        const updatedData = {
          ...data,
          wrongGoods: false,
          excessGoods: false,
          damageGoods: false,
          other: false,
        };

        updatedData[name] = checked;

        return updatedData;
      }
      return data;
    });

    this.setState({ inputList: updatedList });
  };

  handleOtherNoteChange(e, id) {
    const updatedList = this.state.inputList.map((data) => {
      if (data.id === id) {
        return {
          ...data,
          OtherNote: e.target.value,
        };
      }
      return data;
    });

    this.setState({ inputList: updatedList });
  }

  resetSearch() {
    this.setState({
      name: "",
    });
  }

  searchData(e) {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    this.setState({ noRecordFound: false, loading: true }, () => {
      getallUsers(this.state.name, this.state.page, obj).then((res) => {
        const dontShowThisRole = [8, 4];
        const filteredData = res.data.data.filter((x) =>
          dontShowThisRole.includes(x.role),
        );

        const searchUser = filteredData.map((x) => ({
          value: x.id,
          label: x.name,
        }));

        const { current_page, last_page, next_page_url, prev_page_url } =
          res.data;

        const paginationData = Array.from(
          { length: last_page },
          (_, i) => i + 1,
        );

        const nextdisabled = current_page === last_page ? "1" : null;
        const prevdisabled = current_page === 1 ? "1" : null;

        this.setState({
          searchUserDeatils: filteredData,
          searchUser: searchUser,
          paginationData: paginationData,
          currentPage: current_page,
          nextdisabled: nextdisabled,
          prevdisabled: prevdisabled,
          nextpage: next_page_url ? next_page_url.split("=").pop() : "#",
          prevpage: prev_page_url ? prev_page_url.split("=").pop() : "#",
          loading: false,
          user_detail: "",
        });

        if (filteredData.length === 0) {
          this.setState({
            noRecordFound: true,
            nextdisabled: "1",
            prevdisabled: "1",
            paginationData: [],
          });
        }
      });
    });
  }

  inputOnChange = (event, i) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.sendToParent(self.state.name.trim(), i);
      }, 500),
    });
  };
  setInputRef = (el, index) => {
    if (!this.inputRef.current) {
      this.inputRef.current = {};
    }
    this.inputRef.current[index] = el;
  };
  handleWholeReasonChange = (selected) => {
    this.setState({ wholeReason: selected });

    const updatedList = this.state.inputList.map((item) => {
      return {
        ...item,
        wrongGoods: selected.value === "Wrong Goods",
        excessGoods: selected.value === "Excess Goods",
        damageGoods: selected.value === "Damage Goods",
        other: selected.value === "Other",
        OtherNote:
          selected.value === "Other" ? this.state.globalOtherNote || "" : "",
      };
    });

    this.setState({ inputList: updatedList });
  };

  // handleSelectChange = (index, value) => {
  //   let name = "description";
  //   const list = [...this.state.inputList];
  //   list[index][name] = value.value;
  //   var temp_arr = [];

  //   if (list[index]["item_type"] == "1") {
  //     this.state.medication_detail.map((pac) => {
  //       if (list[index]["description"] == pac.id) {
  //         list[index]["unitprice"] = parseFloat(pac.price - 0).toFixed(2);
  //       }
  //     });

  //     list[index]["medicationItems"] = temp_arr;
  //     list[index]["selectmedication"] = value;

  //     const data = this.state.medication_detail[index].map((medi) => {
  //       if (list[index]["description"] == medi.id) {
  //         list[index]["unitprice"] = parseFloat(medi.unit_price - 0).toFixed(2);

  //         list[index]["total_quantity"] = medi.total_quantity;
  //         list[index]["availableQuantity"] = medi.total_quantity;
  //         list[index]["total_allocated"] = medi.total_allocated;

  //         list[index]["selling_price"] = medi.price;
  //         list[index]["barcode"] = medi.barcode;
  //       }
  //     });

  //     list[index]["subtotal"] =
  //       list[index]["unitprice"] * list[index]["quantity"];
  //     list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

  //     this.setState({ inputList: list, totalcost: "", discountamount: 0 });

  //     var new_array = this.state.medicationItems;
  //     new_array[index] = [];
  //     this.setState({ medicationItems: new_array });
  //   } else if (list[index]["item_type"] == "2") {
  //     this.state.labpackage.map((repo) => {
  //       if (list[index]["description"] == repo.id) {
  //         list[index]["unitprice"] = parseFloat(repo.price - 0).toFixed(2);
  //       }
  //     });

  //     list[index]["medicationItems"] = temp_arr;
  //     list[index]["selectmedication"] = value;
  //     const data = this.state.labpackage.map((medi) => {
  //       if (list[index]["description"] == medi.id) {
  //         list[index]["unitprice"] = parseFloat(medi.unit_price - 0).toFixed(2);
  //         list[index]["total_quantity"] = medi.total_quantity;
  //         list[index]["availableQuantity"] = medi.quantity;
  //         list[index]["selling_price"] = medi.price;
  //       }
  //     });

  //     list[index]["subtotal"] =
  //       list[index]["unitprice"] * list[index]["quantity"];
  //     list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);

  //     this.setState({ inputList: list, totalcost: "", discountamount: 0 });

  //     var new_array = this.state.medicationItems;
  //     new_array[index] = [];
  //     this.setState({ medicationItems: new_array });
  //   }
  //   setTimeout(() => {
  //     if (this.selectRefs[index + 1]) {
  //       this.selectRefs[index + 1].focus();
  //     }
  //   }, 100);
  // };

  handleBarcodeNoChange = (event, id, index) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    if (event.target.value[0] === "F") {
      self.setState({
        name: event.target.value.trim(),
        typing: false,
        typingTimeout: setTimeout(function () {
          self.sendToParentBarcodeNot(self.state.name, index);
        }, 500),
      });
    } else {
      self.setState({
        name: event.target.value.substring(1, 7).trim(),
        typing: false,
        typingTimeout: setTimeout(function () {
          self.sendToParentBarcode(self.state.name, index);
        }, 500),
      });
    }
  };

  // sendToParentBarcode = async (name, i) => {
  //   if (this.state.name.length !== 0) {
  //     const list = [...this.state.inputList];
  //     var madpackageItem = [];

  //     if (list[i]["item_type"] == "1") {
  //       let compelte = 1;
  //       let pg_no = 1;
  //       const token = JSON.parse(localStorage.getItem("user"));
  //       const obj = token.token;
  //       var city_id = this.state.city_id;
  //       await searchMedicationForOrder(
  //         this.state.name,
  //         city_id,
  //         pg_no,
  //         obj
  //       ).then(async (res) => {
  //         const list = [...this.state.inputList];

  //         var mdata = res.data.data;

  //         var medicationItems = [];

  //         this.setState({ medication_detail: [] });

  //         res.data.data.map(async (x, i) => {
  //           medicationItems.push({
  //             value: x.id,
  //             label: x.title + "(" + x.item_code + ")",
  //           });
  //         });
  //         list[i]["medicationItems"] = medicationItems;
  //         this.setState({ inputList: list });

  //         var mew_arr = this.state.medicationItems;
  //         mew_arr[i] = medicationItems;
  //         var array1md = this.state.medication_detail;
  //         var array2md = array1md.concat(res.data.data);
  //         var medi_array = [];
  //         medi_array[i] = array2md;

  //         this.setState({
  //           medication_detail: medi_array,
  //           medicationItems: mew_arr,
  //         });
  //         if (medicationItems.length === 1) {
  //           this.handleSelectChange(i, medicationItems[0]);
  //         } else if (medicationItems.length > 1) {
  //           if (this.inputRef.current && this.inputRef.current[i]) {
  //             this.inputRef.current[i].focus();
  //             this.inputRef.current[i].onMenuOpen();
  //           }
  //         }
  //       });
  //     } else if (list[i]["item_type"] == "2") {
  //       this.state.packageItems.map((x, i) => {
  //         madpackageItem.push({
  //           value: x.value,
  //           label: x.label,
  //         });
  //       });
  //       list[i]["medicationItems"] = madpackageItem;
  //     }

  //     this.setState({ inputList: list });
  //     if (list[i]["barcode"]) {
  //       const removeFirstDigit = list[i]["barcode"].slice(1);
  //       if (name === removeFirstDigit) {
  //         this.handleAddClick();
  //       }
  //     }
  //   } else {
  //     const list = [...this.state.inputList];
  //     list[i]["medicationItems"] = [];
  //     this.setState({ inputList: list });
  //     this.setState({ medication_detail: [], medicationItems: [] });
  //   }
  // };
  handleInputChange = (e, index, type) => {
    const { name, value } = e.target;
    const list = [...this.state.inputList];

    list[index][name] = value;

    var subtotal = list[index]["unitprice"] * list[index]["quantity"];
    var addmargin = 0;
    list[index]["subtotal"] =
      (parseFloat(list[index]["unitprice"]) + parseFloat(addmargin)) *
      list[index]["quantity"];
    list[index]["subtotal"] = list[index]["subtotal"].toFixed(2);
    this.setState({
      inputList: list,
    });
  };
  handleMedicineSelectChange = async (selectedOption, index) => {
    const list = [...this.state.inputList];
    const findSelectedMedicine = this.state.localMedicationData.find(
      (med) => med.id === selectedOption.value,
    );
    console.log(findSelectedMedicine, "findSelectedMedicine");
    if (findSelectedMedicine) {
      const addDetails = list.map((item, idx) => {
        if (idx === index) {
          return {
            ...item,
            description: selectedOption,
            unitprice: parseFloat(findSelectedMedicine.price - 0).toFixed(2),
            total_quantity: findSelectedMedicine.total_quantity,
            availableQuantity: Number(findSelectedMedicine.total_quantity),
            total_allocated: Number(findSelectedMedicine.total_allocated),
            selling_price: findSelectedMedicine.price,
            barcode: findSelectedMedicine.item_code,
            subtotal: Number(
              parseFloat(findSelectedMedicine.price - 0).toFixed(2) *
                item.quantity,
            ).toFixed(2),
          };
        }
        return item;
      });

      const availableQuantity = Number(findSelectedMedicine.total_quantity);
      if (
        Number(list[index]["quantity"]) > availableQuantity ||
        0 === availableQuantity
      ) {
        this.setState({ isOverQuantity: index });
      } else {
        this.setState({ isOverQuantity: "" });
      }
      this.setState({ inputList: addDetails }, () => {
        const nextIndex = index + 1;
        if (
          this.inputRef.current &&
          this.inputRef.current[nextIndex] &&
          this.inputRef.current[nextIndex].focus
        ) {
          this.inputRef.current[nextIndex].focus();
        }
      });
    }
  };

  handleRemoveClick = (index) => {
    const list = [...this.state.inputList];
    list.splice(index, 1);
    this.setState({ inputList: list });
  };

  serial = 1;
  getSerial() {
    return this.serial++;
  }
  // sendToParent = async (name, i) => {
  //   if (this.state.name.length !== 0) {
  //     const list = [...this.state.inputList];
  //     var madpackageItem = [];

  //     if (list[i]["item_type"] == "1") {
  //       let compelte = 1;
  //       let pg_no = 1;
  //       var token = JSON.parse(localStorage.getItem("user"));

  //       const obj = token.token;
  //       var city_id = this.state.city_id;
  //       await searchMedicationForOrder(
  //         this.state.name,
  //         city_id,
  //         pg_no,
  //         obj
  //       ).then((res) => {
  //         const list = [...this.state.inputList];
  //         var mdata = res.data.data;
  //         var medicationItems = [];

  //         this.setState({ medication_detail: [] });
  //         res.data.data.map(async (x, i) => {
  //           medicationItems.push({
  //             value: x.id,
  //             label: x.title + "(" + x.item_code + ")",
  //           });
  //         });
  //         list[i]["medicationItems"] = medicationItems;
  //         this.setState({ inputList: list });

  //         var mew_arr = [];
  //         mew_arr[i] = medicationItems;
  //         var array1md = this.state.medication_detail;
  //         var array2md = array1md.concat(res.data.data);
  //         var medi_array = [];
  //         medi_array[i] = array2md;

  //         this.setState({
  //           medication_detail: medi_array,
  //           medicationItems: mew_arr,
  //         });
  //         if (medicationItems.length === 1) {
  //           this.handleSelectChange(i, medicationItems[0]);
  //         }
  //       });
  //     } else if (list[i]["item_type"] == "2") {
  //       this.state.packageItems.map((x, i) => {
  //         madpackageItem.push({
  //           value: x.value,
  //           label: x.label,
  //         });
  //       });
  //       list[i]["medicationItems"] = madpackageItem;
  //     }

  //     this.setState({ inputList: list });
  //   } else {
  //     const list = [...this.state.inputList];
  //     list[i]["medicationItems"] = [];
  //     this.setState({ inputList: list });
  //     this.setState({ medication_detail: [], medicationItems: [] });
  //   }
  // };

  closeModal = () => {
    this.setState({
      showGrnPop: false,
      inputList: [],
      name: "",
      user_detail: "",
      user_detailsError: null,
      wholeReason: "",
      globalOtherNote: "",
    });
  };

  onSubmit() {
    this.setState({ errormessages: [] });
    let error = false;
    const filledRows = this.state.inputList.filter(
      (row) => row.description && row.description.value,
    );
    console.log(filledRows, "fillrow");

    if (!this.state.user_detail.label) {
      error = true;
      this.setState({
        user_detailsError: (
          <small className="text-danger" style={{ padding: "3px" }}>
            User is required.
          </small>
        ),
      });
    } else {
      this.setState({ user_detailsError: null });
    }

    if (filledRows.length === 0) {
      error = true;
      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>Please Enter Proper Medication data!</h4>
          </SweetAlert>
        ),
      });
    } else {
      filledRows.forEach((x) => {
        if (x.description && !x.description.value) {
          error = true;
          this.setState({
            alert: (
              <SweetAlert
                className="order_alert"
                style={{ display: "block", marginTop: "-100px" }}
                onConfirm={() => this.hideAlert()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              >
                <h4>Please Enter Proper Medication data!</h4>
              </SweetAlert>
            ),
          });
        }
      });
    }
    const invalidQuantities = filledRows.filter(
      (item) => Number(item.total_quantity) < Number(item.quantity),
    );
    console.log(this.state.inputList, "inputList");
    if (invalidQuantities.length > 0) {
      error = true;

      this.setState({
        alert: (
          <SweetAlert
            className="order_alert"
            style={{ display: "block", marginTop: "-100px" }}
            onConfirm={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            <h4>
              The Following Medications Have Insufficient Quantities :{" "}
              {invalidQuantities.map((name, index) => (
                <p key={index} style={{ marginTop: "7px" }}>
                  {name.description && name.description.label} Stock :{" "}
                  {name.total_quantity}
                </p>
              ))}
            </h4>
          </SweetAlert>
        ),
      });
    }

    if (!error) {
      this.setState({ isLoading: true });

      const token = JSON.parse(localStorage.getItem("user"));
      const obj = token.token;

      let orderItemsform = filledRows.map((x) => ({
        item_code: x.barcode || "",
        medication_Name: x.description && x.description.label,
        quantity: x.quantity,
        unit_price: x.unitprice || "",
        med_id: x.description && x.description.value,
        reason: x.wrongGoods
          ? "Wrong good"
          : x.damageGoods
            ? "Damage goods"
            : x.excessGoods
              ? "Excess goods"
              : x.OtherNote || "",
      }));
      this.setState({ processing: true }, () => {
        SendGoodReturnValue(obj, {
          items: orderItemsform,
          user_id: this.state.user_detail.id,
        })
          .then(() => {
            this.setState({
              processing: false,
              inputList: [],
              name: "",
              user_detail: "",
              showGrnPop: false,
              isLoading: false,
              wholeReason: "",
              globalOtherNote: "",
            });
            this.getTheDataForTheGoodReturnNote(this.state.currentPage);
          })
          .catch((error) => {
            console.error(
              "API Error:",
              error.response ? error.response.data : getApiErrorMessage(error),
            );
            this.setState({
              processing: false,
              isLoading: false,
            });
          });
      });
    }
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  inputOnChangeUser = (event) => {
    const self = this;

    if (self.state.typingTimeout) {
      clearTimeout(self.state.typingTimeout);
    }

    self.setState({
      name: event.target.value.trim(),
      typing: false,
      typingTimeout: setTimeout(function () {
        self.searchData(self.state.name);
      }, 300),
    });
  };
  onUserChange = (value) => {
    this.setState({
      user_detail: {
        id: value.value || "",
        label: value.label || "",
      },
      searchUser: [],
      user_detailsError: null,
    });
  };
  getTheDataForTheGoodReturnNote(currenPage) {
    const token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;

    getGoodRetunShow(obj, currenPage)
      .then((res) => {
        const getGoodReturnValue = res.data.data;
        this.setState({
          getGoodReturnValue,
        });
      })
      .catch((error) => {
        console.error("Error fetching Good Return Note data:", error);
      });
  }
  paginationHandler() {
    let active = this.state.currentPage;
    let items = [];
    for (let number = 1; number <= this.state.totalPage; number++) {
      items.push(
        <Pagination.Item
          onClick={() => {
            this.setState({ currentPage: number });
            this.getTheDataForTheGoodReturnNote(number);
          }}
          active={number === active}
        >
          {number}
        </Pagination.Item>,
      );
    }
    return items;
  }

  viewPDF(pdfUrl) {
    if (pdfUrl) {
      window.open(pdfUrl, "_blank");
    } else {
      console.error("PDF is not available");
    }
  }
  handleGlobalOtherNote = (e) => {
    const value = e.target.value;
    this.setState({ globalOtherNote: value });
    const updatedList = this.state.inputList.map((item) => {
      if (item.other) {
        return {
          ...item,
          OtherNote: value,
        };
      }
      return item;
    });
    this.setState({ inputList: updatedList });
  };
  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        {this.state.pdfloading ? <LoadingPdfSpinner /> : ""}
        <Grid fluid>
          {this.state.alert}
          <Card
            content={
              <Row>
                <Col
                  xs={12}
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ marginBottom: "40px" }}
                >
                  <Row>
                    <Col xs={2} sm={2} md={2} lg={2} className="text-left">
                      <Button
                        style={{ marginTop: "25px" }}
                        className="fl_mb_web_1 fl_mb_1 w_150 btn-color"
                        onClick={this.openModal}
                      >
                        <i className="fa fa-file" style={{ color: "red" }}></i>{" "}
                        Return Note
                      </Button>
                      &nbsp;
                    </Col>
                  </Row>
                </Col>
                <Col md={12} sm={12} lg={12} xs={12}>
                  <Table responsive className="order_list_table_show">
                    <thead>
                      <tr>
                        <th>#ID</th>
                        <th>User</th>
                        <th>Total</th>
                        <th>status</th>
                        <th>pdf url</th>
                        <th>Created At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.loading ? (
                        <tr>
                          <td colSpan="10">
                            <LoadingSpinner />
                          </td>
                        </tr>
                      ) : this.state.noRecordFound ? (
                        <tr>
                          <td colSpan="10">
                            <center>No record found</center>
                          </td>
                        </tr>
                      ) : (
                        <React.Fragment>
                          {this.state.getGoodReturnValue.map((x) => (
                            <tr key={x.id}>
                              <td>{x.id}</td>
                              <td>{x.supplier ? x.supplier.name : ""}</td>
                              <td>{x.total}</td>
                              <td>{x.status}</td>
                              <td>
                                {x.pdf_url ? (
                                  <Button
                                    onClick={() => this.viewPDF(x.pdf_url)}
                                  >
                                    View
                                  </Button>
                                ) : null}
                              </td>
                              <td>{x.created_at}</td>
                            </tr>
                          ))}
                        </React.Fragment>
                      )}
                    </tbody>
                  </Table>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Pagination bsSize="medium">
                      {this.paginationHandler()}
                    </Pagination>
                  </div>
                </Col>
              </Row>
            }
          />
        </Grid>
        {this.state.isLoading ? <ScreenLoader /> : ""}
        <Modal
          show={this.state.showGrnPop}
          onHide={() => this.setState({ showGrnPop: false })}
          bsSize="large"
          backdrop="static"
          id="increaseWidth"
          style={{ width: "100% !important" }}
        >
          <Modal.Header>
            <Modal.Title>Good Return Note</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col xs={12} sm={12} md={12} lg={12}>
                <Row>
                  <Col xs={4} sm={4} md={4} lg={4} className="text-left">
                    <div
                      onKeyUp={(e) => this.inputOnChangeUser(e)}
                      className="Appy2"
                      style={{ textTransform: "capitalize" }}
                    >
                      <Select
                        style={{ textTransform: "capitalize" }}
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="name"
                        value={
                          this.state.user_detail.id
                            ? {
                                label: this.state.user_detail.label,
                              }
                            : null
                        }
                        onChange={(value) => this.onUserChange(value)}
                        options={this.state.searchUser}
                        placeholder="Select Supplier"
                        noOptionsMessage={() => "Type User Name"}
                      />
                      {this.state.user_detailsError}
                    </div>
                  </Col>
                  <Col xs={2} sm={2} md={2} lg={2} className="text-left">
                    <Button
                      className="fl_mb_web_1 btn-fill fl_mb_1 w_150 btn-color"
                      onClick={() => {
                        this.setState({
                          searchUser: [],
                          user_detail: "",
                        });
                      }}
                    >
                      Reset
                    </Button>
                  </Col>
                  <div>
                    <Col
                      xs={4}
                      sm={4}
                      md={4}
                      lg={4}
                      className="text-left"
                      style={{ float: "right" }}
                    >
                      <Select
                        name="selectReason"
                        value={this.state.wholeReason}
                        placeholder="Reason for Return"
                        onChange={(e) => this.handleWholeReasonChange(e)}
                        options={[
                          { value: "Wrong Goods", label: "Wrong Goods" },
                          { value: "Excess Goods", label: "Excess Goods" },
                          { value: "Damage Goods", label: "  Damage Goods" },
                          { value: "Other", label: "Other" },
                        ]}
                      />
                    </Col>
                  </div>
                </Row>
              </Col>

              <div>
                <Col
                  xs={4}
                  sm={4}
                  md={4}
                  lg={4}
                  className="text-left"
                  style={{ float: "right", marginRight: "4px" }}
                >
                  {this.state.wholeReason.value === "Other" && (
                    <FormGroup style={{ flex: "1 1 100%", marginTop: "8px" }}>
                      <FormControl
                        as="textarea"
                        style={{
                          width: "100%",
                          padding: "8px",
                          height: "50px",
                          border: "1px solid #e3e3e3",
                          borderRadius: "4px",
                          color: "#565656",
                          resize: "none",
                          outline: "none",
                          backgroundColor: "#ffffff",
                        }}
                        placeholder="Reason for Return"
                        value={this.state.globalOtherNote || ""}
                        onChange={(e) => this.handleGlobalOtherNote(e)}
                        rows={4}
                      />
                    </FormGroup>
                  )}
                </Col>
              </div>
            </Row>
            <br />
            <br />
            <div style={{ padding: "5px" }} className="table-responsive">
              <Table className="fl_order_details" style={{ overflow: "auto" }}>
                <thead
                  style={{
                    position: "sticky",
                    top: 0,
                    backgroundColor: "white",
                  }}
                >
                  <tr>
                    <th style={{ textAlign: "center" }}>
                      <ControlLabel>Sr No</ControlLabel>
                    </th>
                    <th style={{ textAlign: "center" }}>
                      <ControlLabel>Item Name</ControlLabel>
                    </th>
                    <th style={{ textAlign: "center" }}>
                      <ControlLabel>Qty</ControlLabel>
                    </th>

                    <th style={{ textAlign: "center" }}>
                      <ControlLabel>Unit Price</ControlLabel>
                    </th>

                    <th style={{ textAlign: "center" }}>
                      <ControlLabel>total</ControlLabel>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.inputList.map((x, i) => {
                    return (
                      <>
                        <tr style={{ width: "100%" }}>
                          <td style={{ width: "5%" }}>
                            <FormControl
                              className="medicine-value"
                              value={i + 1}
                              style={{ textAlign: "center" }}
                              readOnly
                            />
                          </td>
                          <td style={{ width: "35%" }}>
                            <AsyncSelect
                              className="react-select primary"
                              classNamePrefix="react-select"
                              name="description"
                              value={x.description || ""}
                              onChange={(value) =>
                                this.handleMedicineSelectChange(value, i)
                              }
                              loadOptions={this.loadMedicationOptions}
                              cacheOptions
                              defaultOptions={false}
                              ref={(ref) => this.setInputRef(ref, i)}
                              placeholder="Medication"
                              noOptionsMessage={() =>
                                "Type Item Name or Code or Barcode"
                              }
                            />
                          </td>
                          <td style={{ width: "15%" }}>
                            <FormControl
                              className="medicine-value"
                              name="quantity"
                              min={1}
                              value={x.quantity}
                              onChange={(e) =>
                                this.handleInputChange(e, i, "quantity")
                              }
                              onBlur={(e) => {
                                if (
                                  !e.target.value ||
                                  parseInt(e.target.value) <= 0
                                ) {
                                  const list = [...this.state.inputList];
                                  list[i]["quantity"] = 1;
                                  this.setState({ inputList: list });
                                }
                              }}
                              placeholder="0"
                              type="number"
                              style={{ textAlign: "center" }}
                              onWheel={(e) => e.target.blur()}
                            />
                          </td>

                          <td style={{ width: "15%" }}>
                            <FormControl
                              className="medicine-value"
                              name="unitprice"
                              onChange={(e) =>
                                this.handleInputChange(e, i, "unitprice")
                              }
                              value={x.unitprice}
                              placeholder="0.00"
                              type="number"
                              style={{ textAlign: "center" }}
                              onWheel={(e) => e.target.blur()}
                            />
                          </td>

                          <td style={{ width: "15%" }}>
                            <FormControl
                              className="medicine-value"
                              name="totalPrice"
                              onChange={(e) => this.handleInputChange(i)}
                              value={(x.unitprice * x.quantity).toFixed(4)}
                              placeholder="0.0000"
                              type="number"
                              style={{ textAlign: "center" }}
                            />
                          </td>
                          <td style={{ textAlign: "center", width: "5%" }}>
                            <a
                              href="javascript:void(0)"
                              onClick={(e) => this.handleRemoveClick(i)}
                              style={{ fontSize: "16px" }}
                            >
                              X
                            </a>
                          </td>
                        </tr>
                        <div style={{ display: "none" }}>
                          <div>
                            <ControlLabel style={{ marginLeft: "15px" }}>
                              Reason for return
                            </ControlLabel>
                          </div>
                          <div className="reasonForTheGoods">
                            <label
                              style={{
                                display: "flex",
                                marginLeft: "15px",
                                gap: "8px",
                              }}
                            >
                              <input
                                key={x.description}
                                name="wrongGoods"
                                onClick={(e) => this.handleReasonOnChange(e)}
                                value={x.id}
                                type="checkbox"
                                checked={x.wrongGoods || false}
                              />
                              <span style={{ marginTop: "3px" }}>
                                Wrong Goods
                              </span>
                            </label>
                            &nbsp;&nbsp;&nbsp;
                            <label
                              style={{
                                display: "flex",
                                marginLeft: "11px",
                                gap: "8px",
                              }}
                            >
                              <input
                                key={x.description}
                                name="excessGoods"
                                onClick={(e) => this.handleReasonOnChange(e)}
                                value={x.id}
                                type="checkbox"
                                checked={x.excessGoods || false}
                              />
                              <span style={{ marginTop: "3px" }}>
                                Excess Goods
                              </span>
                            </label>
                            &nbsp;&nbsp;&nbsp;
                            <label
                              style={{
                                display: "flex",
                                marginLeft: "11px",
                                gap: "8px",
                              }}
                            >
                              <input
                                key={x.description}
                                name="damageGoods"
                                onClick={(e) => this.handleReasonOnChange(e)}
                                value={x.id}
                                type="checkbox"
                                checked={x.damageGoods}
                              />
                              <span style={{ marginTop: "3px" }}>
                                Damage Goods
                              </span>
                            </label>
                            &nbsp;&nbsp;&nbsp;
                            <label
                              style={{
                                display: "flex",
                                marginLeft: "11px",
                                gap: "8px",
                              }}
                            >
                              <input
                                key={x.description}
                                name="other"
                                onClick={(e) => this.handleReasonOnChange(e)}
                                value={x.id}
                                type="checkbox"
                                checked={x.other}
                              />
                              <span style={{ marginTop: "3px" }}>Other</span>
                            </label>
                            &nbsp;&nbsp;&nbsp;
                            {/* Textarea for Other Reason */}
                            {x.other && (
                              <FormGroup
                                style={{ flex: "1 1 100%", marginTop: "8px" }}
                              >
                                <FormControl
                                  as="textarea"
                                  style={{
                                    width: "100%",
                                    padding: "8px",
                                    height: "50px",
                                    border: "1px solid #e3e3e3",
                                    borderRadius: "4px",
                                    color: "#565656",
                                    resize: "none",
                                    outline: "none",
                                    backgroundColor: "#ffffff",
                                  }}
                                  placeholder="Enter Other Reason"
                                  value={x.OtherNote || ""}
                                  onChange={(e) =>
                                    this.handleOtherNoteChange(e, x.id)
                                  }
                                  rows={4}
                                />
                              </FormGroup>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  })}
                </tbody>
              </Table>
              {this.state.medicationaddError}
            </div>
            <Button className="add-medicine-btn" onClick={this.handleAddClick}>
              {" "}
              <i className="fa fa-plus"></i> Add Medicine
            </Button>
          </Modal.Body>
          <Modal.Footer>
            <Button onClick={this.onSubmit.bind(this)} bsStyle="success" fill>
              Submit
            </Button>
            <Button bsStyle="danger" fill onClick={this.closeModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
export default goodReturnNote;
